import { Model, useStoreActions } from 'pinia-orm';


export default class Mediable extends Model {
  static entity = 'mediables';

  static primaryKey = ['mediaId', 'mediableId', 'mediableType'];

  static fields() {
    return {
      mediaId: this.attr(null),
      mediableId: this.attr(null),
      mediableType: this.attr(null),
      order: this.number(0),
      tag: this.attr(null),
    };
  }

  static creating(_model, _record) {

  }

  static piniaOptions = {
    actions: {
      ...useStoreActions(),
      save(records) {

        this.data = { ...this.data, ...records };
      },
    },
  };

}
